import {
  MEETING_DEBUG_APPEND_CHANNEL,
  MEETING_DEBUG_READ_CHANNEL,
  type MeetingDebugEvent,
  type MeetingDebugReadResponse,
} from '@electron/shared/meeting-debug.types';

import { ElectronAPI } from '../base/ElectronAPI';

export class MeetingDebugAPI extends ElectronAPI {
  append(event: MeetingDebugEvent): void {
    this.invoke<void>(MEETING_DEBUG_APPEND_CHANNEL, event).catch(() => {});
  }

  read(meetingId: string | undefined): Promise<MeetingDebugReadResponse> {
    return this.invoke<MeetingDebugReadResponse>(MEETING_DEBUG_READ_CHANNEL, {
      meetingId,
    });
  }
}
